export default __webpack_public_path__ + "static/media/illustration-study-2-w@2x.dd332db1.webp";